module.exports = __webpack_public_path__ + "media/application/images/2023/02_still-1600x900-0d386aa12da9aeb2b14da58bee08abbc.png";